import { useSettings } from '@atlas/core';
import { isRtlLanguage } from '../helpers/isRtlLanguage';

export const useIsRtl = () => {
  const { lang } = useSettings();
  return isRtlLanguage({ lang });
};
